import axios from './index'
import url from './url'
// 引用fetch.js

function getInfotype (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/getInfotype`,
    { params: typeOne }
  )
}

function getShuxing (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/getShuxing`,
    { params: typeOne }
  )
}

function companyList (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/companyList`,
    typeOne
  )
}

function informationList (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/informationList`,
    typeOne
  )
}

function getMarketDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/companyDetail`,
    { params: typeOne }
  )
}

function getMarketDetailRecommend (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/fujin`,
    { params: typeOne }
  )
}

function getMarketGoodsList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/goodsList`,
    { params: typeOne }
  )
}

function getNoticeList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/noticeList`,
    { params: typeOne }
  )
}

function getCompanyInfoList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/companyInfoList`,
    { params: typeOne }
  )
}

function liuyan (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/liuyan`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}

function guanzhu (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/guanzhu`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}

function browse (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/browse`,
    typeOne
  )
}

function like (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/like`,
    typeOne
  )
}

function footDaohang (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/footDaohang`,
    { params: typeOne }
  )
}

function countryRencaiList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/countryRencaiList`,
    { params: typeOne }
  )
}

function countryCompanyList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/countryCompanyList`,
    { params: typeOne }
  )
}

function storeCompanyList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/storeCompanyList`,
    { params: typeOne }
  )
}

function getLeibie (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getLeibie`,
    { params: typeOne }
  )
}

function getAppcode (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getAppcode`,
    { params: typeOne }
  )
}

function getConditions (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/checkSubaccountConditions`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function getSubaccountList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getSubaccountList`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function getNextsubaccountConditions (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getNextsubaccountConditions`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function addSubaccount (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/addSubaccount`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}
function bindSubaccountPhonenumber (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/bindSubaccountPhonenumber`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}
export {
  bindSubaccountPhonenumber,
  addSubaccount,
  getNextsubaccountConditions,
  getSubaccountList,
  getConditions,
  getInfotype,
  getShuxing,
  companyList,
  informationList,
  getMarketDetail,
  getMarketDetailRecommend,
  getMarketGoodsList,
  getNoticeList,
  getCompanyInfoList,
  liuyan,
  guanzhu,
  browse,
  like,
  footDaohang,
  countryRencaiList,
  countryCompanyList,
  storeCompanyList,
  getLeibie,
  getAppcode
}



// WEBPACK FOOTER //
// ./src/axios/market.js